
/**
 * Authentication and registration of user. Includes cookie management.
 * @author Eduardo Parducci, Andrea Villeda
 */

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { activateUser } from "../../../../../api";
export default {
  name: "ActivateKI",
  props: ["hash"],
  components: {
    Loading,
  },

  /**
   * The vue instance's data object.
   * @property {boolean} error - There has been an error.
   * @property {boolean} isLoading - The page is loading.
   * @property {boolean} fullPage - The whole page is being loaded.
   */
  data() {
    return {
      error: false,
      isLoading: false,
      fullPage: true,
    };
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    this.isLoading = true;
    this.activate().then((res) => {
      this.isLoading = false;
    });
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Activates the account.
     */
    activate() {
      return activateUser(this.hash)
        .then(() => {
          window.setTimeout(() => {
            window.location = "https://werner-beta.dfki.de/ki"; //TODO
          }, 10);
        })
        .catch((err) => {
          this.error = true;
          window.setTimeout(() => {}, 1000);
        });
    },
  },
};


// WEBPACK FOOTER //
// ./src/components/app/authentication/signup/activate/activateKI.js